import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/app/environments/environment';

export const SERVER_API_URL = environment.serverUrl;
const routes = {
  company: {
    getAssignModuleById:(id:any,emp_id:any) => `${SERVER_API_URL}/api/v1/getAssignMenuById/${id}/${emp_id}`,
    company_list: () => `${SERVER_API_URL}/api/v1/getAllCompany`,
    GuestUserCreate: () => `${SERVER_API_URL}/api/v1/createGuestUser`,
    module_name: () => `${SERVER_API_URL}/api/v1/getAll_modules`,
    assign_module:() => `${SERVER_API_URL}/api/v1/assign_menus`,
    create_Payment:(id:any) => `${SERVER_API_URL}/api/v1/updateCompany/${id}`,
    getState_byCountryId:(id:any) =>  `${SERVER_API_URL}/api/v1/getStateByCountryId/${id}`,
    getCity_byStateId:(id:any) =>  `${SERVER_API_URL}/api/v1/getCityByStateId/${id}`,
    all_country:() => `${SERVER_API_URL}/api/v1/getAll_country`,
    get_CompanyById:(id:any) => `${SERVER_API_URL}/api/v1/getCompanyById/${id}`,
    // getAssignModuleById:(id:any) => `${SERVER_API_URL}/api/v1/getAssignMenuById/${id}`,
    updateCompany_byId:(id:any) => `${SERVER_API_URL}/api/v1/updateCompany/${id}`,
    updateAssignMenu_byId:(id:any) => `${SERVER_API_URL}/api/v1/updateAssignMenus/${id}`,
    changeStatus_ById:(id:any) => `${SERVER_API_URL}/api/v1/companyStatus/${id}`,
    
  },



};
@Injectable({
  providedIn: 'root'
})
export class GuestUserService {
  constructor(private http: HttpClient) { }

  getAllCompanyList(): Observable<any> {
    return this.http.get<any>(routes.company.company_list(), { observe: 'response' });
  }

  createGuestUser(data: any): Observable<any> {
    return this.http.post<any>(routes.company.GuestUserCreate(), data, { observe: 'response' });
  }

  getModuleName(): Observable<any> {
    return this.http.get<any>(routes.company.module_name(), { observe: 'response' });
  }


  assignModule(data: any): Observable<any> {
    return this.http.post<any>(routes.company.assign_module(), data, { observe: 'response' });
  }


  createPayment(id:any,data:any): Observable<any> {
    return this.http.put<any>(routes.company.create_Payment(id), data, { observe: 'response' });
  }

  getAllCountry(): Observable<any> {
    return this.http.get<any>(routes.company.all_country(), { observe: 'response' });
  }

  getStateByCountryId(id:any): Observable<any> {
    return this.http.get<any>(routes.company.getState_byCountryId(id), { observe: 'response' });
  }

  getCityByStateId(id:any): Observable<any> {
    return this.http.get<any>(routes.company.getCity_byStateId(id), { observe: 'response' });
  }

  getCompanyById(id:any):Observable<any> {
    return this.http.get<any>(routes.company.get_CompanyById(id), { observe: 'response' });
  }
  getAssignModuleById(id:any,emp_id:any):Observable<any> {
    return this.http.get<any>(routes.company.getAssignModuleById(id,emp_id), { observe: 'response' });
  }


  updateCompanyById(id:any,data:any): Observable<any> {
    return this.http.put<any>(routes.company.updateCompany_byId(id), data, { observe: 'response' });
  }

  updateAssignMenuById(id:any,data:any): Observable<any> {
    return this.http.put<any>(routes.company.updateAssignMenu_byId(id), data, { observe: 'response' });
  }

  changeStatusById(id:any,data:any):Observable<any> {
    return this.http.put<any>(routes.company.changeStatus_ById(id),data, { observe: 'response' });
  }
}